<template>
  <div class="container">
      <div class="row">
        <div class="slopePage__title">
          <b>Применяемые материалы на участках</b>
        </div>
      </div>
      <div class="row usedMaterials">
        <div class="usedMaterials__head">
          <div class="title">
            Материал
          </div>
          <div class="title">
            Участки
          </div>
          <div class="title">
            Объем уклонов
          </div>
          <div class="title">
            Площадь уклонов
          </div>
        </div>
      </div>
      <div class="row usedMaterials__accordion" v-for="(item, i) in usedMaterials" :key="i">
        <div class="usedMaterials__item">
          <div class="usedMaterials__item-img">
            <img :src="getMaterial(item.id).src"
                 :alt="getMaterial(item.id).name">
          </div>
          <div class="usedMaterials__item-data">
            <div class="name"><b>
              {{ getMaterial(item.id).name }}
            </b></div>
            <div class="angle">
              <img src="@/assets/img/angle.svg" alt="angle">
              <b>{{ getMaterial(item.id).angle }}%</b>
            </div>
            <div class="size">{{ item.width }}х{{ item.height }} мм</div>
          </div>
          <div class="usedMaterials__item-count">{{ allSlopes.filter((slope) => {
            return slope.material === item.id && slope.materialSize.width === item.width
            && slope.materialSize.height === item.height;
            }).length }}</div>
          <div class="usedMaterials__item-volume"><span>{{ item.volume }} м³</span></div>
          <div class="usedMaterials__item-square"><span>{{ item.square }} м²</span></div>
          <label :for="`item-${i}`" class="usedMaterials__item-btn"
                 :class="{active: isShow === i}">
            <img src="@/assets/img/select-tick-red.svg" alt="">
            <input type="radio" :value="i" :id="`item-${i}`" v-model.number="isShow"
            @click="closeBody">
          </label>
        </div>
        <div v-if="isShow === i" class="usedMaterials__accordion-body">
          <div class="plate__info-nav">
            <UsedMaterialsNav :id="usedMaterials[isShow].id" :width="item.width"
                              :height="item.height"/>
          </div>
          <div class="plate__info">
            <div class="plate__info-head">
              <div class="title">Тип плиты</div>
              <div class="title scheme">Схема</div>
              <div class="title">К-во плит</div>
              <div class="title">Объем</div>
            </div>
            <div class="plate__info-body">
             <div class="item" v-if="'plateA' in item">
               <div class="item__title">Плита A</div>
               <div class="item__img"><img :src="item.plateA.src" alt="plate A"></div>
               <div class="item__count">{{ item.plateA.count }} шт.</div>
               <div class="item__volume">{{ item.plateA.volume }} м³</div>
             </div>
             <div class="item" v-if="'plateB' in item">
               <div class="item__title">Плита B</div>
               <div class="item__img"><img :src="item.plateB.src" alt="plate B"></div>
               <div class="item__count">{{ item.plateB.count }} шт.</div>
               <div class="item__volume">{{ item.plateB.volume }} м³</div>
             </div>
             <div class="item" v-if="'plateC' in item">
               <div class="item__title">Плита C</div>
               <div class="item__img"><img :src="item.plateC.src" alt="plate C"></div>
               <div class="item__count">{{ item.plateC.count }} шт.</div>
               <div class="item__volume">{{ item.plateC.volume }} м³</div>
             </div>
             <div class="item" v-if="'plateD' in item">
               <div class="item__title">Плита D</div>
               <div class="item__img"><img :src="item.plateD.src" alt="plate D"></div>
               <div class="item__count">{{ item.plateD.count }} шт.</div>
               <div class="item__volume">{{ item.plateD.volume }} м³</div>
             </div>
             <div class="item" v-if="'plateJ' in item">
               <div class="item__title">Плита J</div>
               <div class="item__img"><img :src="item.plateJ.src" alt="plate J"></div>
               <div class="item__count">{{ item.plateJ.count }} шт.</div>
               <div class="item__volume">{{ item.plateJ.volume }} м³</div>
             </div>
             <div class="item" v-if="'plateM' in item">
               <div class="item__title">Плита M</div>
               <div class="item__img"><img :src="item.plateM.src" alt="plate M"></div>
               <div class="item__count">{{ item.plateM.count }} шт.</div>
               <div class="item__volume">{{ item.plateM.volume }} м³</div>
             </div>
              <div class="item" v-if="'plateK' in item">
                <div class="item__title">Плита K</div>
                <div class="item__img"><img :src="item.plateK.src" alt="plate K"></div>
                <div class="item__count">{{ item.plateK.count }} шт.</div>
                <div class="item__volume">{{ item.plateK.volume }} м³</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>

import UsedMaterialsNav from './UsedMaterialsNav.vue';

export default {
  data() {
    return {
      isShow: '',
      width: '',
      height: '',
      /* eslint-disable import/no-unresolved */
      /* eslint-disable global-require */
      // usedMaterials: [],
      /*usedMaterials: [
        {
          id: 3,
          width: 1200,
          height: 600,
          volume: 244.11,
          square: 244.11,
          plateA: {
            count: 100,
            volume: 10,
          },
          plateB: {
            count: 200,
            volume: 20,
          },
          plateC: {
            count: 300,
            volume: 30,
          },
        },
      ],*/
      /* eslint-enable import/no-unresolved */
      /* eslint-enable global-require */
    };
  },
  components: {
    UsedMaterialsNav,
  },
  methods: {
    closeBody() {
      if (this.isShow !== '') {
        this.isShow = '';
      }
    },
    getMaterial(id) {
      return this.allMaterials[this.allMaterials.findIndex(p => p.id === id)];
    },
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    allMaterials() {
      return this.$store.getters.allMaterials;
    },
    allSlopes() {
      return this.$store.getters.allSlopes;
    },
    result() {
      return this.$store.getters.getResult;
    },
    computation() {
      return this.result.total;
    },
    usedMaterials() {
      return this.result.total_group;
    },
  },
};

</script>

<style lang="sass" scoped>
.slopePage
  .usedMaterials
    color: $black
    &__head
      display: grid
      width: 100%
      background: #F6F6F6
      border-radius: rem(4)
      +media((grid-template-columns: (320: 4fr 4fr 5fr, 768: 2fr 3fr 2fr 2fr 3fr)))
      .title
        @extend .common__title-result
        text-align: left
        padding: rem(25) 0
        &:first-of-type
          grid-column-start: 2
          +media((display: (320: none, 768: block)))
        &:first-of-type, &:nth-child(2)
          +media((padding-left: (320: rem(24), 768: rem(40))))
          +media((min-width: (320: rem(102), 768: auto)))
        &:nth-child(3)
          +media((padding-left: (320: rem(24), 768: rem(0))))
          +media((min-width: (320: rem(94), 768: auto)))
        &:nth-child(4)
          +media((padding-left: (320: rem(24), 768: rem(0))))
    &__item
      text-align: left
      background: #fff
      border-radius: rem(4)
      display: grid
      grid-template-columns: 2fr 3fr 2fr 2fr 3fr
      width: 100%
      padding: rem(18) 0
      position: relative
      margin-bottom: rem(1)
      +media((display: (320: flex, 768: grid)))
      flex-direction: row
      flex-wrap: wrap
      &:after
        content: ""
        position: absolute
        top: rem(90)
        left: 0
        right: 0
        margin: auto
        background: #ECECEC
        height: rem(1)
        width: calc(100% - 48px)
        +media((display: (320: block, 768: none)))
      &-img
        display: flex
        flex-direction: row
        align-items: center
        justify-content: flex-end
        +media((order: (320: 1, 768: unset)))
        +media((padding-left: (320: rem(24), 768: 0)))
        img
          +media((max-width: (320: rem(78), 768: rem(92), 800: rem(110), 992: rem(140))))
      &-data, &-count, &-volume, &-square
        display: flex
        flex-direction: column
        align-items: flex-start
        justify-content: center
      &-data
        font-style: normal
        font-weight: 500
        font-size: rem(14)
        line-height: rem(17)
        +media((order: (320: 2, 768: unset)))
        +media((padding-left: (320: rem(26), 768: rem(40))))
        +media((width: (320: 60%, 360: 70%, 768: auto)))
        .name
          padding-bottom: rem(6)
        .angle
          padding-bottom: rem(7)
          img
            margin-right: rem(6)
      &-count
        +media((padding-left: (320: rem(24), 768: rem(40))))
        +media((min-width: (320: rem(102), 768: auto)))
        +media((order: (320: 3, 768: unset)))
        +media((width: (320: calc((100vw / 13) * 4), 768: auto)))
      &-volume
        +media((order: (320: 4, 768: unset)))
        +media((padding-left: (320: rem(24), 768: 0)))
        +media((min-width: (320: rem(94), 768: auto)))
        +media((width: (320: calc((100vw / 13) * 3), 360: calc(100vw / 13 * 4), 768: auto)))
      &-square
        +media((order: (320: 5, 768: unset)))
        +media((padding-left: (320: rem(24), 768: 0)))
        +media((width: (320: calc((100vw / 13) * 5), 768: auto)))
      &-count, &-volume, &-square
        font-style: normal
        font-weight: 500
        font-size: rem(16)
        line-height: rem(30)
        +media((padding-top: (320: rem(14), 768: 0)))
      &-btn
        position: absolute
        right: rem(23)
        transform: translateY(-50%)
        background: none
        box-shadow: none
        border: none
        height: rem(24)
        width: rem(24)
        border: rem(1) solid #ECECEC
        box-sizing: border-box
        border-radius: rem(2)
        cursor: pointer
        display: flex
        flex-direction: column
        justify-content: center
        align-items: center
        transition: .5s
        +media((top: (320: rem(50), 768: 50%)))
        +media((border-color: (320: transparent, 768: #ECECEC)))
        input[type="radio"]
          position: absolute
          opacity: 0
          pointer-events: none
        img
          transition: .5s
          transform-origin: center
        &.active
          img
            transform: rotate(180deg)
    &__accordion
      box-shadow: 0 rem(4) rem(14 ) rgba(0, 0, 0, 0.16)
      &-body
        width: 100%
        background: #FFFFFF
        border-radius: rem(4)
        padding-bottom: rem(40)
        // padding: rem(15) rem(20) rem(34)
        .plate
          &__info
            &-head, &-body
              text-align: left
              color: $black
            &-head
              display: grid
              +media((grid-template-columns: (320: 40% 32% 28%, 600: 3fr 5fr 2fr 2fr)))
              +media((padding: (320: rem(16) rem(24), 600: rem(25) rem(40))))
              .title
                @extend .common__title-result
                &:nth-child(2)
                  text-align: center
              .scheme
                +media((display: (320: none, 600: block)))
            &-body
              .item
                grid-template-columns: 3fr 5fr 2fr 2fr
                display: grid
                +media((padding: (320: 0 rem(24), 600: 0 rem(40))))
                +media((display: (320: flex, 600: grid)))
                flex-wrap: wrap
                &__title
                  +media((order: (320: 1, 600: unset)))
                  +media((width: (320: 40%, 600: auto)))
                &__count
                  +media((order: (320: 2, 600: unset)))
                  +media((width: (320: 32%, 600: auto)))
                &__volume
                  +media((order: (320: 3, 600: unset)))
                  +media((width: (320: 28%, 600: auto)))
                &__title, &__img, &__count, &__volume
                  display: flex
                  flex-direction: row
                  align-items: center
                &__title, &__count, &__volume
                  font-style: normal
                  font-weight: 500
                  font-size: rem(16)
                  line-height: rem(30)
                  +media((padding-top: (320: rem(16), 600: 0)))
                &__img
                  justify-content: center
                  +media((box-shadow: (320: inset 0 rem(-1) 0 #D6D6D6, 600: none)))
                  +media((padding: (320: rem(34) 0, 600: rem(22) 0 rem(17))))
                  +media((order: (320: 4, 600: unset)))
                  +media((width: (320: 100%, 600: auto)))
                  img
                    max-height: rem(105)

</style>
